import * as types from "../actions/types";

const initialState = {
  staff: null,
  basicGroups: null,
  basicCourses: null,
  dopGroups: null,
  dopCourses: null,
  outGroups: null,
  outCourses: null,
  electiveGroups: null,
  positionHistory: null,
  report: null,
  tabLoading: false,
};

export default function educationalStructure(state = initialState, action) {
  switch (action.type) {
    case types.GET_EDUCATIONAL_STRUCTURE:
      return { ...state, staff: action.payload };

    case types.GET_BASIC_EDU_GROUP:
      return { ...state, basicGroups: action.payload };
    case types.GET_BASIC_EDU_COURSES:
      return { ...state, basicCourses: action.payload };

    case types.GET_DOP_EDU_GROUPS:
      return { ...state, dopGroups: action.payload };
    case types.GET_DOP_EDU_COURSES:
      return { ...state, dopCourses: action.payload };

    case types.GET_OUT_EDU_GROUPS:
      return { ...state, outGroups: action.payload };
    case types.GET_OUT_EDU_COURSES:
      return { ...state, outCourses: action.payload };

    case types.GET_ELECTIVE_GROUPS:
      return { ...state, electiveGroups: action.payload };

    case types.GET_POSITION_HISTORY:
      return { ...state, positionHistory: action.payload };

    case types.GET_REPORT:
      return { ...state, report: action.payload };

    case types.SET_EDUCATION_TAB_LOADING:
      return { ...state, tabLoading: action.payload };

    default:
      return state;
  }
}
